module.exports = __webpack_public_path__ + "media/How-to-Reset-My-BAU-Password.87cf7d00.mp4";